// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MapController from "./map_controller"
application.register("map", MapController)

import NewsItemsController from "./news_items_controller"
application.register("news-items", NewsItemsController)

import PlaylistItemsController from "./playlist_items_controller"
application.register("playlist-items", PlaylistItemsController)

import SlugController from "./slug_controller"
application.register("slug", SlugController)
